import styled from 'styled-components';

export const LocationName = styled.h1`
  margin: 0;
  margin-top: 60px;
  max-width: 600px;
  word-wrap: break-word;
  @media (max-width: 1024px) {
    margin-top: 20px;
  }
`;

export const Date = styled.h3`
  margin: 0;
  font-size: 1.1em;
`;

export const WeatherBox = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TodayContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 10px;
  width: 600px;
  @media (max-width: 675px) {
    justify-content: center;
    width: 100%;
  }
  @media (max-width: 600px) {
    align-items: flex-start;
  }
`;
export const TodayTemperature = styled.span`
  font-size: 11rem;
  @media (max-width: 600px) {
    background-image: ${({ src }) => `url(${src})`};
    background-repeat: no-repeat;
    background-position: right bottom;
  }
`;
export const TodayWeather = styled.p`
  margin: 0;
  text-transform: uppercase;
  width: 270px;
  position: relative;
  top: -30px;
`;

export const Span = styled.span`
  text-transform: lowercase;
`;

export const WeatherImg = styled.img`
  height: 160px;
  object-fit: cover;
  @media (max-width: 600px) {
    display: none;
  }
`;
